// extracted by mini-css-extract-plugin
export default {"shared":"'../../../shared.module.css'","md":"768px","radioContainer":"RadioButton_radioContainer__qqgTV","subQuestion":"RadioButton_subQuestion__Kp6vc"};